// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2rKlc","header":"MergedInvoice_header__3g63W"};